import CTAButton from "./CTAButton";

export default function SolutionSection({ content = {}, productImage, onCheckout, canCheckout }) {
  const title = content.title || "Solusi Alami dari Bahan Pilihan";
  const desc = content.desc || "";
  const points = content.points || [];

  return (
    <section className="py-20 lg:py-28 bg-background">
      <div className="mx-auto max-w-6xl px-5 grid lg:grid-cols-2 gap-12 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 h-32 w-32 rounded-full bg-[oklch(0.52_0.22_25/0.1)] blur-2xl" />
          <div className="absolute -bottom-6 -right-6 h-40 w-40 rounded-full bg-[oklch(0.62_0.24_22/0.2)] blur-3xl" />
          <img
            src={productImage}
            alt="Produk Premium"
            className="relative rounded-3xl shadow-luxury w-full aspect-square object-cover"
          />
          <div className="absolute top-4 right-4 bg-white rounded-full px-4 py-2 text-xs font-bold text-primary shadow-card">
            ★ Premium Quality
          </div>
        </div>
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Solusi Alami</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
            {title}
          </h2>
          {desc && (
            <p className="mt-6 text-muted-foreground leading-relaxed text-lg">
              {desc}
            </p>
          )}
          {points.length > 0 && (
            <ul className="mt-6 space-y-3">
              {points.map((t, i) => (
                <li key={i} className="flex items-center gap-3 text-foreground">
                  <span className="h-6 w-6 rounded-full bg-[oklch(0.52_0.22_25/0.1)] text-primary grid place-items-center text-sm">✓</span>
                  {t}
                </li>
              ))}
            </ul>
          )}
          <div className="mt-8">
            <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
              🛒 Beli Sekarang
            </CTAButton>
          </div>
        </div>
      </div>
    </section>
  );
}
